"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var referenceObject_1 = require("./referenceObject");
/**
 * Gets a ReferenceObject from an element.
 *
 * @param el the element to get a reference object from
 */
exports.getClassReferences = function (el) {
    return ((el.dataset.classReferences &&
        JSON.parse(el.dataset.classReferences)) ||
        referenceObject_1.newObject());
};
/**
 * Sets the class references for an element.
 *
 * @param el the element to set a reference object on
 * @param classReferences the references to set
 */
exports.setClassReferences = function (el, classReferences) {
    el.dataset.classReferences = JSON.stringify(classReferences);
};
//# sourceMappingURL=element.js.map